import styles from "./PcrsPanel.module.css";

const TONE_CLASS = {
  info: styles.info,
  error: styles.error,
};

// Card shared by the PCRS notices: icon, title, lead line, then whatever the
// notice needs (steps, buttons) indented under the title.
export const PcrsPanel = ({ icon: Icon, title, lead, tone = "info", children, ...rest }) => (
  <section className={`${styles.panel} ${TONE_CLASS[tone] ?? TONE_CLASS.info}`} role="alert" {...rest}>
    <div className={styles.header}>
      <Icon size={22} className={styles.icon} aria-hidden />
      <div className={styles.headerText}>
        <h3 className={styles.title}>{title}</h3>
        {!!lead && <p className={styles.lead}>{lead}</p>}
      </div>
    </div>

    {!!children && <div className={styles.body}>{children}</div>}
  </section>
);
